import tw from 'twin.macro';

export const GiftsWrapper = tw.div`w-full h-full px-4 py-4 pb-[5.375rem] md:(px-32 py-10 pb-0)  flex flex-col justify-start items-start gap-6 `;

export const GiftsHeader = tw.div`w-full max-w-[18.813rem] flex flex-col gap-3`;

export const GiftsCurrentCoins = tw.div`w-[11.5rem] h-[1.813rem] bg-[#D4F4BF] text-[14px] font-bold capitalize text-[#161F21] text-opacity-50
        flex justify-center items-center gap-2 rounded-full
`;

// Gift grid
export const GiftGrid = tw.div`grid grid-cols-2 md:grid-cols-3 gap-3 w-fit h-3/4 overflow-y-auto pb-5`;

export const BackButton = tw.button`
 flex flex-col justify-center items-center w-11 h-11
 bg-lightBlue border-2 border-darkGray rounded-lg
`;

export const RedeemContent = tw.div`w-full h-full flex py-8 flex-col justify-center items-center gap-16`;

export const RedeemContentInfo = tw.div`w-full flex flex-col justify-start items-center gap-0 capitalize`;

export const RedeemInfoTitle = tw.div`px-10 py-2 flex justify-center items-center bg-softYellow`;

export const RedeemInfoText = tw.h1`text-[4.5rem] font-bold uppercase -m-4`;

export const RedeemAction = tw.div`w-full  flex flex-col justify-center items-center gap-6 mt-9
    [&>span]:(text-[1rem] font-bold)
    [&>button]:([&>div]:(h-[3.811rem] border-[3px]))
`;

export const RedeemActionText = tw.div`w-full flex flex-col justify-center items-center 
`;

export const RedeemLocation = tw.h2`text-[1rem] font-bold`;

export const RedeemWarning = tw.div`w-full flex justify-center items-center gap-3 capitalize`;

export const Warning = tw.img`w-5 h-5 object-contain`;
